module.exports = __webpack_public_path__ + "img/lg_ring_g_e_0_0@2x.0d5f94dd.png";